import { rgba } from 'polished'

const animationDuration = {
    short: 0.4,
    medium: 0.8,
    average: 1,
    long: 1.4,
    veryLong: 2.6,
}

const animationDelay = {
    short: 0.3,
    medium: 0.6,
    long: 1,
}

const animationStaggerChildren = 0.02

const animationScale = {
    tiny: 0.9,
    small: 0.98,
    medium: 1,
    large: 1.04,
}

const mainTitle = {
    hidden: {
        opacity: 0,
        y: 20,
        scale: animationScale.small,
    },
    show: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: {
            duration: animationDuration.medium,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

const mainTitleImage = {
    hidden: {
        opacity: 1 /* opacity animated from css */,
        scale: animationScale.large,
    },
    show: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: animationDuration.veryLong,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

const splitContainerFirst = {
    hidden: {
        opacity: 0,
        y: 500,
    },
    show: {
        opacity: 1,
        y: 0,
        transition: {
            delay: animationDelay.short,
            duration: animationDuration.medium,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

const splitContainerSecond = {
    hidden: {
        opacity: 0,
        y: 500,
    },
    show: {
        opacity: 1,
        y: 0,
        transition: {
            delay: animationDelay.long,
            duration: animationDuration.medium,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

const scrollExplore = {
    hidden: {
        opacity: 0,
        y: 20,
    },
    show: {
        opacity: 1,
        y: 0,
        transition: {
            delay: animationDelay.medium,
            duration: animationDuration.average,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

const verticalLine = {
    hidden: {
        scaleY: 0,
    },
    show: {
        scaleY: 1,
        transition: {
            delay: animationDelay.long * 1.5,
            duration: animationDuration.medium,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

const singleImage = {
    hidden: {
        opacity: 0,
    },
    show: {
        opacity: 1,
        transition: {
            delay: animationDelay.medium,
            duration: animationDuration.long,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

const backgroundMaskContainer = {
    hidden: {
        backgroundColor: rgba(247, 246, 243, 1),
    },
    show: {
        backgroundColor: rgba(247, 246, 243, 0),
        transition: {
            delay: 0,
            duration: animationDuration.long,
            ease: [0.455, 0.03, 0.515, 0.955],
            staggerChildren: 2.5,
        },
    },
}

const backgroundMaskItem = {
    hidden: { opacity: 1 },
    show: { opacity: 0 },
}

const paragraphContainer = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            delay: animationDelay.short,
            duration: animationDuration.medium,
            ease: [0.455, 0.03, 0.515, 0.955],
            staggerChildren: animationStaggerChildren,
        },
    },
}

const paragraphContainerSlow = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            delay: animationDelay.short,
            duration: animationDuration.medium,
            ease: [0.455, 0.03, 0.515, 0.955],
            staggerChildren: animationStaggerChildren * 3,
        },
    },
}
const paragraphContainerSlowDelayed = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            delay: animationDelay.long,
            duration: animationDuration.medium,
            ease: [0.455, 0.03, 0.515, 0.955],
            staggerChildren: animationStaggerChildren * 3,
        },
    },
}

const paragraphItem = {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
}

const paragraphSingle = {
    hidden: {
        opacity: 0,
        y: 100,
    },
    show: {
        opacity: 1,
        y: 0,
        transition: {
            delay: animationDelay.short,
            duration: animationDuration.medium,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

const paragraphSingleHighlight = {
    hidden: {
        opacity: 0,
        y: 100,
    },
    show: {
        opacity: 1,
        y: 0,
        transition: {
            delay: animationDelay.medium,
            duration: animationDuration.medium,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

const overlapImage = {
    hidden: {
        opacity: 0,
        scale: animationScale.medium,
    },
    show: {
        opacity: 1,
        scale: 1,
        transition: {
            delay: animationDelay.short,
            duration: animationDuration.long,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

const zoomImage = {
    hidden: {
        scale: 1,
    },
    show: {
        scale: 1.2,
        transition: {
            delay: 0,
            duration: animationDuration.long * 6,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

const backgroundFade = {
    hidden: {
        backgroundColor: rgba(33, 33, 33, 1),
    },
    show: {
        backgroundColor: rgba(33, 33, 33, 0),
        transition: {
            delay: 0,
            duration: animationDuration.medium,
            ease: [0.455, 0.03, 0.515, 0.955],
        },
    },
}

export const animationVariants = {
    mainTitle: mainTitle,
    mainTitleImage: mainTitleImage,
    splitContainerFirst: splitContainerFirst,
    splitContainerSecond: splitContainerSecond,
    scrollExplore: scrollExplore,
    verticalLine: verticalLine,
    singleImage: singleImage,
    backgroundMaskContainer: backgroundMaskContainer,
    backgroundMaskItem: backgroundMaskItem,
    paragraphContainer: paragraphContainer,
    paragraphContainerSlow: paragraphContainerSlow,
    paragraphContainerSlowDelayed: paragraphContainerSlowDelayed,
    paragraphItem: paragraphItem,
    paragraphSingle: paragraphSingle,
    paragraphSingleHighlight: paragraphSingleHighlight,
    overlapImage: overlapImage,
    zoomImage: zoomImage,
    backgroundFade: backgroundFade,
}
